import { render } from "./RCheckbox.vue?vue&type=template&id=cf45866c"
import script from "./RCheckbox.vue?vue&type=script&lang=js"
export * from "./RCheckbox.vue?vue&type=script&lang=js"

import "./RCheckbox.vue?vue&type=style&index=0&id=cf45866c&lang=css"
script.render = render

export default script